<template>
    <div class="associated-solutions" v-if="!noSolution">
        <h3 class="title is-2">{{ tabs.length>1 ? $t("solutions") : tabs[0].label }}</h3>
        <div class="tabs" v-if="!$store.state.settings.isPhone && tabs.length>1">
            <span
                v-for="tab in tabs"
                :key="tab.code"
                class="tab"
                :class="{ active: selectedTab === tab.code, solo:tabs.count===1 }"
                @click="selectedTab = tab.code"
            >
                {{ tab.label }}
            </span>
        </div>
        <b-select
            v-else-if="tabs.length>1"
            v-model="selectedTab"
            size="is-large"
            rounded
        >
            <option
                v-for="tab in tabs"
                :key="tab.code"
                :value="tab.code"
            >
                {{ tab.label }}
            </option>
        </b-select>

        <div class="accessories-tab-content" v-if="selectedTab === 'accessories'">
            <div class="accessories-list">
                <card-accessory
                    v-for="accessory in previewAccessories"
                    :key="accessory.identifier"
                    class="content-item"
                    :datas="accessory"
                    :save-route="false"
                />
            </div>
            <div class="show-more-container">
                <router-link
                    :to="{ name: 'machine-sheet-accessories', params: {id: productDatas.identifier, name: slugifyName(productDatas)}}"
                    class="button is-primary is-large is-rounded is-uppercase"
                    :class="brandBackgroundColor"
                >
                    <span>{{ $t("see_all_accessories") }}</span>
                    <span class="icon-arrow-right is-tiny is-right-side"></span>
                </router-link>
            </div>
        </div>
        <div class="equipments-tab-content" v-if="selectedTab === 'equipments'">
            <equipment-list :equipments="productDatas.equipments" />
            <div class="show-more-container">
                <router-link
                    :to="{ name: 'machine-sheet-equipments', params: {id: productDatas.identifier, name: slugifyName(productDatas)}}"
                    class="button is-primary is-large is-rounded is-uppercase"
                    :class="brandBackgroundColor"
                >
                    <span>{{ $t("see_all_equipments") }}</span>
                    <span class="icon-arrow-right is-tiny is-right-side"></span>
                </router-link>
            </div>
        </div>
        <div class="services-tab-content" v-if="selectedTab === 'services'">
            <div class="services-list">
              <hooper :itemsToShow="itemToShow">
                <slide
                    v-for="service in productDatas.services"
                    :key="service.code">
                  <card-service
                      class="content-item"
                      :datas="service"
                      :save-route="false"
                      :with-picture="true"
                      :is-sheet-block="true"
                  />
                </slide>
              </hooper>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters, mapState} from 'vuex'

    import CardAccessory from "@/components/Card/CardAccessorySummary.vue"
    import EquipmentList from "@/components/Equipment/EquipmentList.vue"
    import CardService from "@/components/Card/CardService.vue"
    import Product from '@/services/serli/product'
import {Hooper, Slide} from "hooper";

    export default {
        name: 'AssociatedSolutions',

        components: {
            CardAccessory,
            EquipmentList,
            CardService,
            Hooper,
            Slide,
        },
        data() {
            return {
                tabs: [],
                noSolution : true,
                selectedTab: 'services',
                itemToShow: 3,
            }
        },
        computed: {
            ...mapState({
                productDatas: state => state.sheet.productDatas,
                isLargeDesktop: state => state.settings.isLargeDesktop,
                isSmallDesktop: state => state.settings.isSmallDesktop,
                isTablet: state => state.settings.isTablet,
                isPhone: state => state.settings.isPhone,
                isPortrait: state => state.settings.isPortrait,
            }),
          ...mapGetters({
            localeKebabFormat: 'settings/localeKebabFormat'
          }),
          previewAccessories() {
            return this.accessoriesItems ? this.productDatas.attachments_products.slice(0,this.accessoriesItems) : this.productDatas.attachments_products
          },
          accessoriesItems() {
            if(this.isLargeDesktop)
              return 4
            if(this.isSmallDesktop)
              return 4
            if(this.isTablet)
              return 3
            if(this.isPhone)
              return 5
            return 5;
          },
        },
        created() {
          this.startLoading();
          this.fetchAccessories()
              .then(() => this.fetchServices())
              .then(() => this.fetchEquipments())
                .finally(() => {
                  this.activeTab();
                  this.stopLoading();
                });

          this.changeItemToShow();

        },
        methods: {
            changeItemToShow() {
              if(this.isTablet && !this.isPortrait)
                this.itemToShow = 3;
              else if (this.isPhone && this.isPortrait )
                this.itemToShow = 1;
              else if(this.isPhone && !this.isTablet && !this.isPortrait)
                this.itemToShow = 2;
              else
                this.itemToShow = 3;
            },
            async fetchAccessories(){
              if(this.productDatas.attachments_products && this.productDatas.attachments_products.length>0) this.tabs.push({
                code: "accessories",
                label: this.$t('key_accessories'),
              })
            },
            async fetchEquipments(){
              //En attente d'information

              if(1===0) this.tabs.push({
                code: "equipments",
                label: this.$t('key_equipments')
              });

            },
            async fetchServices(){
              await Product.services({ brand: 'manitou',locale: this.localeKebabFormat, }).then(response => {
                this.productDatas.services=response.data.data
                this.tabs.push({
                  code: "services",
                  label: this.$t('key_services'),

                })
              })
            },
            activeTab(){
              this.noSolution=true;
              if (this.tabs.length>0) {
                  var tab = this.tabs[0];
                  this.selectedTab = tab['code'];
                  this.noSolution = false;
              }
            }
        }
    }
</script>

<style lang="scss">
.associated-solutions {
    .title {
        margin-bottom: 20px;
    }

    .accessories-tab-content {
        .accessories-list {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            width: 100%;
            margin: 20px -10px;

            .content-item {
                margin: 10px 10px;

                @media #{$mq_phone} {
                    flex: 1 1 auto;
                    margin-right: 0;
                }
            }
        }
    }

    .equipments-tab-content {
        .show-more-container {
            margin-top: 20px;
        }
    }

    .services-tab-content {
      margin-right: -30px;
      margin-left: -30px;
        .services-list {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            width: 100%;
            //margin: 20px -10px;
        }

        .content-item {
            margin: 10px 10px;

            @media #{$mq_phone} {
                flex: 1 1 auto;
                margin-right: 0;
            }
        }
    }

    .show-more-container {
        @media #{$mq_phone} {
            text-align: center;
        }
    }

  .hooper {
    height: auto;

    /deep/ .hooper-list {
      padding: 40px 30px 80px;
      margin-top: -40px;
      margin-bottom: -40px;
    }
  }
}
</style>
